import { Legacyprofile as LegacyprofileData } from '@/payload-types'
import { LegacyProfileCardComponent } from '@/components/legacy-profile-profile-card/profileCard'

import Link from 'next/link'

interface IProps {
  profileData: (string | null) | LegacyprofileData
}

export const LegacyCompactPostProfileCard = ({ profileData }: IProps) => {
  let href = ''
  if (typeof profileData === 'object') {
    const isProfessor = profileData?.professions?.some(
      (profession) => profession?.profession === 'professor',
    )
    href = isProfessor ? `/professor/${profileData?.slug}` : `/individual/${profileData?.slug}`
  }

  return (
    <Link className={'flex flex-col items-center w-[116px] px-1 mb-3'} href={href} target="_blank">
      <LegacyProfileCardComponent
        profileData={profileData}
        profilePicture={{
          pictureDivCSS: 'h-20 w-20',
          pictureCSS: 'rounded-full shadow-md default-border',
        }}
        profileFullName={{
          fullNameDivCSS: 'text-center mt-1 !leading-[17.5px]',
          fullNameCSS: 'font-semibold text-sm !leading-[17.5px]',
        }}
      />
    </Link>
  )
}

export default LegacyCompactPostProfileCard
